<template>
    <b-modal id="PriorAuthorizationModal" size="lg" :visible="!NotOpenByDefault ? true : false"  :no-close-on-backdrop="true" :no-close-on-esc="true" scrollable centered :title="TitleWindow"  @ok="this.emitEventOK" @hide="emitEventHide" :cancel-title="$t('Shared.BtnCancel')">
        <div id="showPriorAuthorizationOutCome">
            <MdTitle v-bind:Text="$t('Insurance.PriorAuthorization')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
            <b-col md="3" lg="3" sm="12">
                <MdCheckBox
                    v-bind:Label="$t('Insurance.PriorAuthorizationNot')" 
                    v-bind:Name="'checkbox-prior'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"
                    v-model="disablePriorAuth"
                    v-bind:isReadOnly="this.isReadOnly"
                />
            </b-col>
            <b-row>
                <div class="col-sm-12 col-md-3">                      
                <MdButton
                    v-bind:Label="$t('Insurance.AddPriorAuthor')" 
                    v-bind:ClassProp="this.isReadOnly ? 'btn btn-primary my-3 btn-block' : 'btn btn-primary my-3 btn-block btn-login'"
                    v-bind:IconClass="'ti-plus pr-1'"                
                    v-on:click="CallModalTable"
                    v-bind:Name="'btnaddPriorAuthor'"
                    v-bind:isReadOnly="this.isReadOnly">
                </MdButton>
                </div>
                <div class="col-sm-12 col-md-9 mb-4">
                    <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                        <div class="input-group">
                        <input 
                            type="text" 
                            class="form-control"
                            v-model="searchPrior"   
                            @keyup.enter="FindPrior">
                            <div class="input-group-append">
                            <div class="input-group-append">
                                <MdButton 
                                v-bind:Name="'btnsearchinput'"
                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'"
                                v-on:click="FindPrior">
                                </MdButton>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-row>
            <div class="row">
                <div class="col-md-12">
                        <MdTablePaginationClient 
                            v-bind:fields="visibleFields"
                            v-bind:items="priorAuthorizations"
                            v-bind:totalRows="totalRows" 
                            v-bind:IsInsurancePrior="true"  
                            v-bind:isReadOnly="false"          
                            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                            v-bind:currentPage="currentPage"
                            v-bind:perPage="perPage"
                            v-bind:pageOptions="pageOptions"
                            :onFiltered="onFilteredPrior"
                            :pageChanged="pageChangedPrior"
                            v-bind:VisibleEditIcon="true"
                            :deleteIconEvent="RemovePrior"
                            :editIconEvent="EditPrior"
                            :RowClick="RowClickPrior"
                            v-bind:VisibleDeleteIcon="true"
                            :onRowSelected="onRowSelectedPrior"
                            :perPageFunction="PerPageFunctionPrior">
                        </MdTablePaginationClient>
                </div>
            </div>
        </div>
        <div class="text-center text-md-right mt-3 container-button">
              <MdButton
                v-bind:Label="$t('Shared.Save')"
                v-bind:ClassProp="(this.isReadOnly)?'primary mx-2':'primary btn-login mx-2'"
                v-on:click="SaveOrEdit"
                v-bind:isReadOnly=this.isReadOnly
              />
        </div>
      <ModalPriorAutho
        v-bind:TitleWindow="$t('Insurance.PriorAuthorization')"  
        v-bind:ModeEdit="ModalPriorModeEdit"       
        @getCodeConditionOK="OnReturnData($event)"
        v-bind:ModalId="this.modalId">
      </ModalPriorAutho>

    </b-modal>
</template>

<script>
import ShowMessage from "@/components/messages/ShowMessage.js";
import DBFunctions from '@/common/DBFunctions.js'
import InsuranceService from "@/services/insurance.service";
import { EventBus } from '@/event-bus.js';
import Permission from '@/common/Permission'
import PriorAuthorizationService from "@/services/priorauthorization.service";
import Utils from "@/common/utils";

export default {
    name: "MdPriorAuthorization",
    mixins: [ShowMessage, DBFunctions, Permission],

    props: {
     PatientCode:String,
     TitleWindow: String,
     NotOpenByDefault:Boolean,
    },

    data() {
        return {
            parameter: {
                SearchCriteria: "",
                PageNumber: 0,
                PageSize: 0,
                PatientCode: "",
            },
            PatientInsurance: { 
                address1:"",
                address2:"",
                catcode: "",
                city:"",
                country:"",
                coverage: "",
                disablePriorAuth:false,
                discount:null,
                dob:null,
                effectiveDate:null,
                eligibility: "",
                eligibilityDate: null,
                employment: "",
                homePhone:"",
                initial: "",
                insCode:"",
                insFirstname: "",
                insGroup: "",
                insGroupName: "",
                insLastname:"",
                insNo: "",
                insType: "",
                isEligible: "",
                medicareType: "",
                patientcode: "",
                paymentpercent: null,
                reason: "",
                relation: "",
                sex: "",
                state: "",
                workPhone:"",
                zip: "",
                //showPriorAuthorization:false,
                showPriorAuthorization:false,
                priorAuthorizationBaseOn:"",
                priorAuthorizations:[]
            },
            isReadOnly: false,
            isListing: true,
            isEditMode:true,
            disablePriorAuth:false,
            modalId:"idModalPriorAutho",
            pageOptions: [5, 10, 15],
            totalRows: 0,
            currentPage: 1,
            ShowMessageIsEmpty:false,
            perPage: 10,
            Loading: true,
            ModalPriorModeEdit:false,
            PriorAuthoListCopy:[],
            priorAuthorizations:[],
            FieldsPrior:[
                { key: 'entityDescription', sortable: true, label: this.$t('Shared.Description'), class:'text-rigth',visible:true }, 
                { key: 'entityCode', sortable: true, label: this.$t('Shared.Code'), class:'text-rigth',visible:true  },          
                { key: 'datefrom', sortable: true, label: this.$t('Shared.datefrom'), class: 'text-rigth',visible:true  },
                { key: 'dateto', sortable: true, label: this.$t('Shared.dateTo'), class: 'text-rigth',visible:true  },  
                { key: 'status', sortable: true, label: this.$t('Shared.Status'), class: 'text-rigth',visible:true  }, 
                { key: 'isActive', sortable: true, label: 'Status', class: 'hidden',visible:false }, 
                { key: 'unit', sortable: true, label: this.$t('Insurance.DayUnit'), class: 'text-rigth',visible:true  },  
                { key: 'quantityUsed', sortable: true, label: this.$t('Insurance.QTYUsed'), class: 'text-rigth',visible:true  },            
                { key: 'recid', sortable: true, label: 'recid', class: 'hidden',visible:false },
                { key: 'key', sortable: true, label: 'key', class: 'hidden',visible:false },
                { key: 'priorauthorization', sortable: true, label: this.$t('Insurance.PriorAuthorizationNo'), class: 'text-rigth',visible:true },   
            ],
            clickOK: false,
            searchPrior:"",
            InsuranceCodeTable: "",
            InsCode: ""
        }
    },

    methods: {
        onFilteredPrior(){

        },

        pageChangedPrior(){

        },

        RemovePrior(){

        },

        EditPrior(){

        },

        onRowSelectedPrior(){

        },

        PerPageFunctionPrior(){

        },

        RowClickPrior(){

        },

        emitEventOK(){      
            this.clickOK = true
        },

        emitEventHide(handled){
            if (this.pendingChanges) {
                handled.preventDefault()
                this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                    title: this.$tc('Prior Authorization'),
                    okTitle: this.$t('Shared.Save'),
                    cancelTitle: this.$t('Shared.BtnDismiss'),
                    footerClass: 'p-2',
                    titleClass: 'modal-title modal-type-warning'
                })
            .then(value => {
                if(!value){
                this.$emit('getCancel');
                this.ResetProps();
                }
            })		
            } else {
                if(this.clickOK) {
                    this.$emit('getCodeConditionOK', this.getTextResult());
                    this.$emit('input',this.getTextResult());
                    this.parameter.SearchCriteria = '';
                } else {
                    this.$emit('getCancel');
                    this.ResetProps();
                }
            }
        },

        getTextResult() {
            let textResult = '';
            let insuranceName = '';
            this.items.map(item => (
                insuranceName = item.insuranceName ? item.insuranceName: '',
                textResult = textResult + ' '+this.$tc('Insurance.Insurance')+': '+ insuranceName+' '+this.$t('Shared.Type')+': '+item.insuranceTypeDescription +' '+ this.$t('Insurance.PolicyNo')+': '+item.policyNo + ' '+ this.$t('Shared.Relation')+': '+item.relation +"\n"
            ))
            return textResult
        },

        ResetProps(){
            this.editMode = false;
            this.parameter.SearchCriteria = '';
            this.isEditMode = false;
            this.isListing = true;
        },

        ExistKeyinListCopy(key){
            var result = false;
            var arr = this.PriorAuthoListCopy;     
            arr.forEach(element => {
                if(element.key === key){
                result = true;
                }
            });
            return result;
        },

    
        ExistKeyinList(key){
            var result = false;
            var arr = this.priorAuthorizations;     
            arr.forEach(element => {
                if(element.key === key){
                result = true;
                }
            });
            return result;
        },

        focusOut() {
            this.PatientInsurance.paymentpercent = this.formattedCurrencyValue ? parseFloat(
                this.formattedCurrencyValue.toString().replace("$ ", "")) : null;
            if (isNaN(this.PatientInsurance.paymentpercent)) {
                this.PatientInsurance.paymentpercent = 0;
            }
            this.formattedCurrencyValue = this.formattedCurrencyValue ?
                "$" +
                this.PatientInsurance.paymentpercent
                .toFixed(2)
                .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,") : null;
        },

        focusIn() {
            this.formattedCurrencyValue = this.PatientInsurance.paymentpercent;
        },

        focusOut1() {
            this.PatientInsurance.discount = this.formattedCurrencyValue1 ? parseFloat(
                this.formattedCurrencyValue1.replace("$ ", "")
            ): null;
            if (isNaN(this.PatientInsurance.discount)) {
                this.PatientInsurance.discount = 0;
            }
            this.formattedCurrencyValue1 = this.formattedCurrencyValue1 ?
                "$ " +
                this.PatientInsurance.discount
                .toFixed(2)
                .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,"): null;
        },

        focusIn1() {
            this.formattedCurrencyValue1 = this.PatientInsurance.discount;
        },

        FindPrior(){
            this.priorAuthorizations = this.PriorAuthoListCopy;
            var arr = this.priorAuthorizations;
            var temp = [];
            if(this.searchPrior){
                arr.forEach(element => {
                if(element.entityDescription && element.entityDescription.toUpperCase().includes(this.searchPrior.toUpperCase())
                || element.entityCode.toString() && element.entityCode.toString().toUpperCase().includes(this.searchPrior.toUpperCase())
                || element.datefrom && element.datefrom.toUpperCase().includes(this.searchPrior.toUpperCase())
                || element.dateto && element.dateto.toUpperCase().includes(this.searchPrior.toUpperCase())
                || element.unit !== null && element.unit.toString() && element.unit.toString().toUpperCase().includes(this.searchPrior.toUpperCase())
                || element.quantityUsed !== null && element.quantityUsed.toString() && element.quantityUsed.toString().toUpperCase().includes(this.searchPrior.toUpperCase()) 
                || element.priorauthorization && element.priorauthorization.toString().toUpperCase().includes(this.searchPrior.toUpperCase()) 
                || element.status && element.status.toString().toUpperCase() === this.searchPrior.toUpperCase()){
                    temp.push(element);
                }
                });
            } else {
                temp = this.PriorAuthoListCopy;
            }
        
            this.priorAuthorizations = temp;
            this.totalRows = this.priorAuthorizations.length;
        },

        CallModalTable(){
            this.ModalPriorModeEdit = false;
            this.DataPriorAutho = 
                {          
                    "datefrom":"",
                    "dateto":"",
                    "entityCode":"",
                    "entityDescription":"",
                    "isActive":true,
                    "status":"",
                    "priorauthorization":"",
                    "quantityUsed":"",
                    "recid":"",
                    "key":Math.floor(new Date().valueOf() * Math.random()),
                    "unit":0,
                    "priorAuthorizationBaseOn":this.priorAuthorizationBaseOn
                };
                var data = {
                    row: this.DataPriorAutho,
                    ModeEdit:false
                } 
            EventBus.$emit('OnReceivedData',data); 
            this.$bvModal.show(this.modalId);     
        },

        UpdatePriorAuthoList(data){
            var arr = this.priorAuthorizations;
            arr.forEach(element => {
                if(element.key === data.key){
                element.datefrom =  data.datefrom;
                element.dateto =  data.dateto;
                element.entityCode =  data.entityCode;
                element.status = data.status,
                element.entityDescription =  data.entityDescription;
                element.isActive =  data.isActive;
                element.priorauthorization =  data.priorauthorization;
                element.quantityUsed =  data.quantityUsed;
                element.recid =  data.recid;
                element.key =  data.key;
                element.unit =  data.unit;
                element.priorAuthorizationBaseOn =  data.priorAuthorizationBaseOn;  
                }
            });
            this.priorAuthorizations = arr;


            var arrcopy = this.PriorAuthoListCopy;
            arrcopy.forEach(element => {
                if(element.key === data.key){
                element.datefrom =  data.datefrom;
                element.dateto =  data.dateto;
                element.entityCode =  data.entityCode;
                element.status = data.status,
                element.entityDescription =  data.entityDescription;
                element.isActive =  data.isActive;
                element.priorauthorization =  data.priorauthorization;
                element.quantityUsed =  data.quantityUsed;
                element.recid =  data.recid;
                element.key =  data.key;
                element.unit =  data.unit;
                element.priorAuthorizationBaseOn =  data.priorAuthorizationBaseOn;  
                }
            });
            this.PriorAuthoListCopy = arrcopy;
        },

        OnReturnData(datapro){
            let data = {...datapro};  
            if (data.datefrom)	
                data.datefrom = Utils.formatterDateToString(data.datefrom);
            if (data.dateto)	
                data.dateto = Utils.formatterDateToString(data.dateto);

            if(!this.ExistKeyinListCopy(data.key)){    
                this.PriorAuthoListCopy.push(data);
            }
                
            if(!this.ExistKeyinList(data.key)){       
                this.priorAuthorizations.push(data);
            // this.PriorAuthoListCopy.push(data);
                //this.FormatDate();
            }else{       
                this.UpdatePriorAuthoList(data);
            }  

            
            this.totalRowsPrior = this.priorAuthorizations.length;
        },

        getInsurance() {
            this.parameter.PatientCode = this.PatientCode;
            InsuranceService.getAllPatientInsurances(this.parameter)
                .then((response) => {
                if (response.status == "200" && response.data && response.data.length > 0) {
                    this.items = response.data;
                    this.items = this.items.filter(e => e.insuranceCode == "DCS")
                    this.InsuranceCodeTable = this.items[0].recId
                    this.InsCode = this.items[0].insuranceCode
                    this.getPatientInsuranceID()
                    this.getInsuranceByCode(this.InsCode)
                    this.getPriorAuthoByPatientAndinsCode()
                    this.Loading = false;
                    this.$emit("load", this.Loading);
                }
                this.Loading = false;
                this.$emit("load", this.Loading);
                })
                .catch((error) => {
                    console.log(error)
                    this.Loading = false;
                    this.$emit("load", this.Loading);
                    if (!error.response) {
                        // network error
                        this.showMessage(
                        this.$tc('Msg.Error'),
                        this.$t('Msg.RetrieveInformation'),
                        "error"
                        );
                    } else {
                        this.showMessage(this.$tc('Msg.Error'), error, "error");
                    }
                });
        },

        getInsuranceId(idInsurance) {
            InsuranceService.getInsuranceByCode(idInsurance)
                .then((response) => {
                if (response.status == '200' && response.data) {
                    this.Insurance = response.data;
                    this.PatientInsurance.catcode = this.Insurance.category;
                    this.InsuranceCategory = this.Insurance.categoryDescription;
                    
                }
                })
                .catch((error) => {
                if (!error.response) {
                    // network error
                    console.log(error)
                    this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('Msg.retrieveInfo'),
                    "error"
                    );
                } else {
                    this.showMessage(this.$tc('Msg.Error'), this.$t('Insurance.NotValidInsuranceCode', { idInsurance: idInsurance }), "error");
                }
            });
        },

        getPatientInsuranceID() {
            this.$emit('load', true);
            InsuranceService.getPatientInsurancesById(this.InsuranceCodeTable)
                .then((response) => {
                if (response.data) {
                    this.PatientInsurance = response.data;
                    this.hasInsuranceData();
                    this.totalRowsPrior = this.PatientInsurance.priorAuthorizations && this.PatientInsurance.priorAuthorizations.length > 0 ? this.PatientInsurance.priorAuthorizations.length : 0; 
                    this.PriorAuthoListCopy = response.data.priorAuthorizations;
                    this.PatientInsurance.priorAuthorizations.forEach(function(element) { 
                        element.key = Math.floor(new Date().valueOf() * Math.random());            
                        if (element.datefrom)	
                        element.datefrom = Utils.formatterDateToString(element.datefrom);
                        if (element.dateto)	
                        element.dateto = Utils.formatterDateToString(element.dateto); 
                    });           
                    this.getInsuranceId(this.PatientInsurance.insCode);
                    this.PatientInsurance.effectiveDate = Utils.formatterDate(
                    this.PatientInsurance.effectiveDate
                    );
                    this.PatientInsurance.dob = Utils.formatterDate(
                    this.PatientInsurance.dob
                    );
                    this.formattedCurrencyValue1 = this.PatientInsurance.discount
                    ? "$ " + this.PatientInsurance.discount
                    : "";

                    this.formattedCurrencyValue = this.PatientInsurance.paymentpercent
                    ? "$ " + this.PatientInsurance.paymentpercent
                    : "";
                    this.focusOut();
                    this.focusOut1();
                    
                    this.enabledInsuredChecked = (this.PatientInsurance.relation.indexOf("01") == 0);
                    this.checkedUsePatientInfo = this.enabledInsuredChecked;
                    this.$emit('load', false);   
                }
                })
                .catch((error) => {
                    this.$emit('load', false);   
                    console.log(error)
                    if (!error.response) {
                        // network error
                        this.showMessage(
                        this.$tc('Msg.Error'),
                        this.$t('Msg.retrieveInfo'),
                        "error"
                        );
                    } else {
                        this.showMessage(this.$tc('Msg.Error'), error, "error");
                    }
                });
        },

        getInsuranceByCode(code){  
            InsuranceService.getInsuranceByCode(code)
                    .then((response) => {
                        if(response.status == '200' && response.data){
                            this.InsuranceByCode = response.data;   
                            this.priorAuthorizationBaseOn = this.InsuranceByCode.priorAuthorizationBaseOn;   
                            this.isEditMode = false;
                            this.isEditMode = true;               

                            let visible = this.priorAuthorizationBaseOn !== 'NONE' ? true:false;                   
                            this.FieldsPrior.forEach(element => {
                                if(!visible){
                                    if(element.key === 'entityDescription' || element.key === 'entityCode'){
                                        element.visible = false;
                                        element.class = 'hidden';                           
                                    }
                                } else {
                                    if(element.key === 'entityDescription' || element.key === 'entityCode'){
                                        element.visible = true;
                                        element.class = 'text-rigth';
                                    }
                                }
                            });
                        }                             
                    })
                    .catch((error) => {
                        console.log(error)
                        if (error.response) {
                            this.showMessage(this.$tc('Msg.Error'),error,"error");
                        }
                    });
        },

        getPriorAuthoByPatientAndinsCode() { 
            this.Loading = true;
            this.$emit("load", this.Loading);
            var params = {
                SearchCriteria:"",       
                PatientCode:this.PatientCode.trim(),
                InsuranceCode: this.InsCode
            }   
            PriorAuthorizationService.getAll(params)
                .then((response) => {
                    if (response.data) {
                        this.priorAuthorizations = response.data;
                        this.isEditMode = false;
                        this.isEditMode = true;
                        this.priorAuthorizations.forEach(function(element) { 
                            element.key = Math.floor(new Date().valueOf() * Math.random());            
                            if (element.datefrom)	
                            element.datefrom = Utils.formatterDateToString(element.datefrom);
                            if (element.dateto)	
                            element.dateto = Utils.formatterDateToString(element.dateto); 

                        this.totalRowsPrior = this.priorAuthorizations.length;
                        });
                    }
                    if(this.priorAuthorizations.length == 0) {
                        this.ShowMessageIsEmpty = true
                    }           
                    this.Loading = false;
                    this.$emit("load", this.Loading);            
                })
                .catch((error) => {
                    this.Loading = false;
                    console.log(error)
                    this.$emit("load", this.Loading);
                    if (error.response) {
                    this.showMessage(this.$tc('Msg.Error'), error, "error");
                    }
                });      
        },

        hasInsuranceData() {
            // Define the keys you want to check
            const requiredKeys = [
                'insFirstname', 'insLastname', 'address1', 'address2', 'city','country',
                'dob', 'employment', 'homePhone', 'initial',  'state', 'workPhone' ,'zip'
            ];

            this.checkedInfo = false
            // Check if *at least one* key has a non-empty value
            for (const key of requiredKeys) {
                if (this.PatientInsurance[key]) {
                this.checkedInfo = true
                return true; // If one is found, return true immediately
                }
            }
            // If none of the keys have values, return false
            return false; 
        },

        PrepareInsurance(){     
            this.PatientInsurance.priorAuthorizations.forEach(element => {      
                element.datefrom = Utils.formatterToISO(element.datefrom, Utils.getShortDateFormat());
                element.dateto = Utils.formatterToISO(element.dateto, Utils.getShortDateFormat());               
            });
        },

        UpdateInsurance() {
            this.PatientInsurance.priorAuthorizations = this.PriorAuthoListCopy;
            this.PrepareInsurance();
            InsuranceService.updatePatientInsurances(
                this.InsuranceCodeTable,
                this.PatientInsurance
            )
                .then((response) => {
                if (response.status == '200' && response.data) {
                    this.showMessage(this.$t('Msg.Success'), this.$t('Insurance.InsuranceSavedSuccessfully'), "success");
                    this.$emit('load', false);
                }
                })
                .catch((error) => {
                if (!error.response) {
                    this.showMessage(
                    this.$tc('Msg.Error'),
                    this.$t('Msg.NotAbleToUpdate'),
                    "error"
                    );
                } else {
                    this.showMessage(this.$tc('Msg.Error'), error.response.data.errorMessage, "error");
                }
            });
        },

        SaveOrEdit() {
            this.UpdateInsurance()
        },
        
    },
    computed: {
        visibleFields() {     
            return this.FieldsPrior.filter(field => field.visible)
        }
    },
    created() {
        this.getInsurance()
    }
}


</script>